import { AddToWishlist } from '../../wish-list/components/popups/add-to-wishlist/add-to-wishlist';
import HeartIcon from '../../../ui/svg/common/heart';

interface IProductWishlist {
    skuid: number;
}

const ProductWishlist = ({ skuid }: IProductWishlist) => {

    return (
        <AddToWishlist skuid={ skuid }>
            <button
                title={ `Add to wishlist` }
                type="button"
                className="product__wishlist-btn cursor-pointer bg-white m-2 p-2 shadow-md absolute left-0 top-0 z-10">
                <HeartIcon width="15px" color="#1d1d1d" />
            </button>
        </AddToWishlist>
    )
};

export default ProductWishlist;